import React from 'react'
import { Link } from 'gatsby'
import t from 'prop-types'
import Image from '../Images/Image'
import ImageRounded from '../Images/ImageRounded'
import SectionHeader from '../Headers/SectionHeader'
import WYSIWYG from '../WYSIWYG'
import ButtonPrimary from '../Links/ButtonPrimary'
import cx from 'classnames'

const MediaText = ({
  image,
  isOnDarkBg,
  isImageRounded,
  reverse,
  reverseMobile,
  text,
}) => {
  const isImageRoundedMap = {
    true: {
      component(image) {
        return (
          <ImageRounded reverse={reverse} src={image.src} alt={image.alt} />
        )
      },
    },
    false: {
      component(image) {
        return <Image src={image.src} alt={image.alt} />
      },
    },
  }
  const ImageType = isImageRoundedMap[isImageRounded]

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
      <div
        className={cx('last:mb-0', {
          'lg:order-last pl-5 lg:pl-0': reverse,
          'pr-5 lg:pr-0': !reverse,
          'order- md:order-first': reverseMobile,
        })}
      >
        {text.sectionHeader && (
          <SectionHeader
            isOnDarkBg={isOnDarkBg}
            {...text.sectionHeader}
          ></SectionHeader>
        )}
        <div className="mt-8">
          <WYSIWYG isOnDarkBg={isOnDarkBg} content={text.copy} />
          {text.link && (
            <div className="mt-8">
              <ButtonPrimary as={Link} {...text.link} isOnDarkBg>
                {text.link.label}
              </ButtonPrimary>
            </div>
          )}
        </div>
      </div>
      {image && (
        <div className="mb-16 md:mb-0 last:mb-0">
          {ImageType.component(image)}
        </div>
      )}
    </div>
  )
}

MediaText.propTypes = {
  image: t.object,
  isOnDarkBg: t.bool,
  isImageRounded: t.bool,
  reverse: t.bool,
  reverseMobile: t.bool,
  text: t.object,
}

MediaText.defaultProps = {
  reverse: false,
  isOnDarkBg: false,
  isImageRounded: false,
}

export default MediaText
